function Departments(props) {
  const data = props.data;
  const theme = props.theme ?? {};
  const accentBg = theme.accent ?? "bg-sky-500";
  const cardBorder = theme.cardBorder ?? "hover:border-sky-400/60";
  const degreeText = theme.degreeText ?? "text-sky-600";

  const renderLink = () => {
    if (data.url && data.url !== "") {
      return (
        <a
          href={`../${data.url}`}
          className={`inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full ${accentBg} hover:opacity-80 text-white text-sm font-semibold transition-opacity duration-200 no-underline`}
        >
          Find Out More
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-3.5 h-3.5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </a>
      );
    }
  };

  return (
    <div className={`flex flex-col h-full rounded-xl p-5 bg-white border border-stone-200 ${cardBorder} transition-colors duration-200 shadow-sm`}>
      <div className={`w-8 h-0.5 ${accentBg} rounded-full mb-3`} />
      <h3 className={`text-base font-bold ${degreeText} mb-2 leading-snug`}>
        {data.degree}
      </h3>
      <p className="text-sm leading-relaxed text-stone-500 mb-4 flex-1">
        {data.shortDesc}
      </p>
      <div className="mt-auto pt-2">
        {renderLink()}
      </div>
    </div>
  );
}

export default Departments;
